import React from "react";

/**
 * Loader animation
 *
 * @component Loader
 *
 */
const Loader = () => (
  <div className="loader">
    <svg className="svg">
      <circle cx="70" cy="70" r="70"></circle>
    </svg>
  </div>
);

export default Loader;
